<template>
  <b-modal ref="resultCalculationModal" size="lg" :title="title">
    <div v-if="this.done && !this.error" class="text-center">
      <p>Berechnung erfolgreich beendet</p>
      <p>{{ this.timer.display }}</p>
    </div>

    <div v-else-if="this.done" class="text-center">
      Berechnung fehlgeschlagen
    </div>

    <div v-else-if="!calculating" class="text-center">
      <p><strong>Achtung!</strong> Hiermit werden alle bisherigen Ergebnisse gelöscht!</p>
      <div>
        <input class="form-check-input" type="checkbox" id="country" v-model="mode.country">
        <label class="form-check-label" for="country">Bundeswertung</label>
      </div>
      <div>
        <input class="form-check-input" type="checkbox" id="state" v-model="mode.state">
        <label class="form-check-label" for="state">Landeswertung</label>
      </div>
      <div>
        <input class="form-check-input" type="checkbox" id="school" checked disabled>
        <label class="form-check-label" for="school">Schulwertung</label>
      </div>
    </div>

    <div v-else-if="calculating" class="text-center">
      <p>Berechnung läuft... <font-awesome-icon icon="spinner" class="fa-spin"></font-awesome-icon></p>
      <p>{{ this.timer.display }}</p>
    </div>

    <div slot="modal-footer" class="w-100">
      <b-btn size="sm" class="float-left" variant="danger" v-on:click="calculate" :disabled="calculating">{{ startButtonTitle }}</b-btn>
      <b-btn size="sm" class="float-right" variant="secondary" v-on:click="close">{{cancelButtonTitle}}</b-btn>

    </div>
  </b-modal>
</template>
<script>

export default {
  name: 'ResultCalculationModal',
  props: ['competition'],

  data: function () {
    return {
      title: 'Ergebnisse berechnen',
      mode: {
        country: true,
        state: true
      },
      calculating: false,
      timer: {
        interval: null,
        seconds: 0,
        display: '0:00'
      },
      done: false,
      error: null
    }
  },

  computed: {
    startButtonTitle: function () {
      if (this.done) {
        return 'Neu starten'
      }

      return 'Starten'
    },
    cancelButtonTitle: function () {
      if (this.done) {
        return 'Beenden'
      }

      return 'Abbrechen'
    }
  },

  beforeDestroy: function () {
    if (this.timer.interval) {
      clearInterval(this.timer.interval)
    }
  },

  methods: {
    close: function () {
      this.done = false
      this.error = null
      clearInterval(this.timer.interval)

      this.$refs.resultCalculationModal.hide()
    },

    show: function () {
      this.$refs.resultCalculationModal.show()
    },

    tick: function () {
      this.timer.seconds++

      let minutes = Math.floor(this.timer.seconds / 60)
      let seconds = this.timer.seconds - (minutes * 60)

      this.timer.display = minutes + ':' + (seconds < 10 ? '0' : '') + seconds
    },

    calculate: function () {
      this.calculating = true
      this.done = false
      this.error = null
      this.timer.interval = window.setInterval(this.tick, 1000)

      const body = this.mode

      let prms = new Promise((resolve, reject) => {
        this.$eventHub.$emit(
          'download',
          '/competitions/' + this.competition.id + '/prices',
          'POST',
          body,
          resolve,
          reject
        )
      })

      prms.then(() => {
        this.error = null
      })

      prms.catch((err) => {
        this.error = err
      })

      prms.finally(() => {
        this.calculating = false
        this.done = true
        clearInterval(this.timer.interval)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/competitions/prices/ResultCalculationModal.vue